import {PureComponent} from 'react';

const TEST_SOUND = '/assets/sounds/ring.mp3';

type Props = {
    onError: (error: Error) => void
};

export default class MediaPlayCheck extends PureComponent<Props> {
    private sound: HTMLAudioElement;

    componentDidMount() {
        this.sound = new Audio(TEST_SOUND);
        this.sound.volume = 0.01;
        this.checkMedia();
    }

    private async checkMedia(): Promise<void> {
        const {onError} = this.props;

        try {
            await this.sound.play();
        } catch (e: any) {
            onError(e);
        } finally {
            this.sound.pause();
        }
    }

    render() {
        return null;
    }
}
